import { stats } from '@/mocks/topics';

export default function StatsStrip() {
  return (
    <section aria-label="网站数据" className="w-full rounded-lg bg-foreground-950 px-6 py-8 md:px-10">
      <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
        {stats.map((item, index) => (
          <div key={item.label} className="flex flex-col">
            <span
              className={`font-heading text-3xl font-black md:text-4xl ${
                index === 1 ? 'text-accent-400' : 'text-background-50'
              }`}
            >
              {item.value}
            </span>
            <span className="mt-1 font-label text-sm text-background-300">{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}